import './Aside.scss';

import cn from 'classnames';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import LinkLikeButton from '@/common/components/blocks/LinkLikeButton/LinkLikeButton';
import ButtonLoading from '@/common/components/molecules/ButtonLoading/ButtonLoading';
import { ROUTE_CARTS, ROUTE_CHECKOUT } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import Total from '@/ebat/components/blocks/Aside/Total/Total';

import { AsideDefaultProps, AsidePropTypes } from './Aside.proptypes';

const Aside = ({
  cart,
  className,
  disabled,
  isLoading,
  isUpdated,
  onPutCartItems,
}) => {
  const { t } = useTranslation();
  const { user, zergRush } = useAuth();

  const isDisabled = useMemo(() => {
    const blocked = disabled || isLoading;
    const noSelection =
      blocked || cart?.items.filter((item) => item.is_selected).length === 0;

    return {
      disabled: blocked,
      loading: isLoading,
      validate:
        blocked ||
        noSelection ||
        zergRush ||
        !user?.functionality_accesses?.carts ||
        !user?.functionality_accesses?.carts_order_validate,
    };
  }, [cart, disabled, isLoading, user, zergRush]);

  return (
    <div
      className={cn('standalone-aside', className)}
      data-qa-id="aside-standalone-cart"
    >
      <Total isUpdated={isUpdated} total={cart.subtotal} />
      {isUpdated ? (
        <ButtonLoading
          context="aside-standalone-cart-update"
          buttonSize="x-large"
          disabled={isDisabled.disabled}
          isLoading={isDisabled.loading}
          onClick={onPutCartItems}
          variant="primary"
        >
          {t('ebat:entities:cart.aside.button.update')}
        </ButtonLoading>
      ) : (
        <LinkLikeButton
          buttonSize="x-large"
          className="button--validate"
          context="aside-standalone-cart-save"
          disabled={isDisabled.validate}
          url={`${ROUTE_CARTS}/${cart.id}${ROUTE_CHECKOUT}`}
          variant="primary"
        >
          {t('ebat:entities:cart.aside.button.validate')}
        </LinkLikeButton>
      )}
    </div>
  );
};

Aside.defaultProps = {
  ...AsideDefaultProps,
};

Aside.propTypes = {
  ...AsidePropTypes,
};

export default Aside;
